// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__wy04N","accordion":"_styles_accordion__ETa0m","arrowSvg":"_styles_arrowSvg__y83Aa"};